import React, { useContext } from 'react';
import styled from 'styled-components';

import KpiSlideOutContext from '../contexts/KpiSlideOutContext';
import { Z_INDEX } from '../../../../constants';

export const SLIDE_OUT_WIDTH = 440;

const SlideOutDiv = styled.div`
  height: 100%;
  background-color: var(--color-bg-primary);
  z-index: ${Z_INDEX.SLIDE_OUT};
  position: absolute;
  width: ${SLIDE_OUT_WIDTH}px;
  right: 0px;
  box-shadow: 0px 1px 12px 5px #3f3f441a;
  border-radius: 2px;
`;

const KpiSlideout = ({
  children,
}: {
  children: JSX.Element | JSX.Element[] | false;
}) => {
  const { isOpen } = useContext(KpiSlideOutContext);

  if (!isOpen) {
    return null;
  }

  return <SlideOutDiv>{children}</SlideOutDiv>;
};

export default KpiSlideout;
